import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText } from "lucide-react";

export default function ExportToolbar({ onExcel, onPDF, onPrint }) {
  return (
    <div className="flex items-center gap-2 no-print">
      {onExcel && (
        <Button variant="outline" onClick={onExcel} className="h-8" data-testid="btn-export-excel">
          <FileSpreadsheet className="w-4 h-4 mr-1.5" /> Excel
        </Button>
      )}
      {onPDF && (
        <Button variant="outline" onClick={onPDF} className="h-8" data-testid="btn-export-pdf">
          <FileText className="w-4 h-4 mr-1.5" /> PDF
        </Button>
      )}
      {onPrint && (
        <Button variant="outline" onClick={onPrint} className="h-8" data-testid="btn-print-report">
          Print
        </Button>
      )}
    </div>
  );
}
